import { RedeterminationScreen } from "@/interactors/RedeterminationScreen";

export default function Redetermination() {
  return <RedeterminationScreen />;
}
